export default __webpack_public_path__ + "static/media/480_private03-es-web.ca492ec6.png";